export const EditAccountContent = {
  // Page title
  title: 'Edit Account',

  // Password section
  password: {
    title: 'Change Password',
    description: 'Set a password to sign in faster without using email links.',
    button: 'Set Password',
    dialog: {
      title: 'Set Password',
      description:
        'Create a password to sign in without using email links. You can still use email links if you prefer.',
      newPasswordLabel: 'New Password',
      newPasswordPlaceholder: 'Enter new password (min. 6 characters)',
      confirmPasswordLabel: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm new password',
      cancel: 'Cancel',
      update: 'Update Password',
      updating: 'Updating...',
      updated: 'Updated!',
      success: 'Password updated successfully!',
      errors: {
        mismatch: 'Passwords do not match',
        tooShort: 'Password must be at least 6 characters long',
        unexpected: 'An unexpected error occurred. Please try again.',
      },
    },
  },

  // Name section
  name: {
    title: 'Name',
    description: 'Update your display name',
    label: 'Full Name',
    placeholder: 'Enter your full name',
    save: 'Save Name',
    saving: 'Saving...',
    saved: 'Saved!',
    success: 'Name updated successfully!',
    errors: {
      required: 'Name is required',
      unexpected: 'An unexpected error occurred. Please try again.',
    },
  },

  // Email section
  email: {
    title: 'Email',
    description:
      'Update your email address. You will need to confirm the new email address.',
    label: 'Email Address',
    placeholder: 'Enter your email address',
    save: 'Save Email',
    saving: 'Saving...',
    saved: 'Saved!',
    success:
      'Email update request sent! Please check your new email for confirmation.',
    errors: {
      required: 'Email is required',
      invalid: 'Please enter a valid email address',
      unexpected: 'An unexpected error occurred. Please try again.',
    },
  },
} as const;


